import React from 'react';
import { motion } from 'framer-motion';
import { CalendarCheck, Clock, Award } from 'lucide-react';
export function PricingSection() {
  return <section className="py-24 bg-cream" data-id="element-141">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-143">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-144">
            ¿Cuánto Puedes Ganar?
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg" data-id="element-145">
            Este es un negocio de confianza. Puedes estructurar tus cobros de
            tres formas diferentes según lo que acuerdes con el agente.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto mb-16" data-id="element-146">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:-translate-y-1 transition-transform duration-300" data-id="element-147">
            <div className="w-12 h-12 bg-cream rounded-lg flex items-center justify-center mb-6" data-id="element-148">
              <CalendarCheck className="w-6 h-6 text-gold-dark" data-id="element-149" />
            </div>
            <h3 className="text-xl font-bold text-navy mb-2" data-id="element-150">Por Cita</h3>
            <div className="text-3xl font-serif font-bold text-navy mb-4" data-id="element-151">
              $15-$20{' '}
              <span className="text-sm font-sans font-normal text-gray-500" data-id="element-152">
                /cita
              </span>
            </div>
            <p className="text-gray-600" data-id="element-153">
              Cobras por cada cita confirmada que logres poner en la agenda del
              agente. Ideal para empezar.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-navy rounded-2xl p-8 shadow-lg border border-navy-light relative transform md:-translate-y-4" data-id="element-154">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gold text-navy-dark text-xs font-bold uppercase tracking-wider py-1 px-3 rounded-full" data-id="element-155">
              Más Popular
            </div>
            <div className="w-12 h-12 bg-navy-light rounded-lg flex items-center justify-center mb-6" data-id="element-156">
              <Clock className="w-6 h-6 text-gold" data-id="element-157" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-158">Pago Semanal</h3>
            <div className="text-3xl font-serif font-bold text-white mb-4" data-id="element-159">
              $100-$150{' '}
              <span className="text-sm font-sans font-normal text-gray-400" data-id="element-160">
                /semana
              </span>
            </div>
            <p className="text-gray-300" data-id="element-161">
              Un pago fijo por estar pendiente de sus mensajes 3 o 4 horas al
              día. Ingreso predecible y seguro.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:-translate-y-1 transition-transform duration-300" data-id="element-162">
            <div className="w-12 h-12 bg-cream rounded-lg flex items-center justify-center mb-6" data-id="element-163">
              <Award className="w-6 h-6 text-gold-dark" data-id="element-164" />
            </div>
            <h3 className="text-xl font-bold text-navy mb-2" data-id="element-165">Por Resultados</h3>
            <div className="text-3xl font-serif font-bold text-navy mb-4" data-id="element-166">
              Base + Bono
            </div>
            <p className="text-gray-600" data-id="element-167">
              Un pago base pequeño más un bono significativo si la casa se llega
              a vender gracias a tu gestión.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-168">
          <p className="inline-block text-lg md:text-xl font-serif text-navy-light border-b-2 border-gold/30 pb-1" data-id="element-169">
            "La constancia es lo que te dará los $500 mensuales o más."
          </p>
        </motion.div>
      </div>
    </section>;
}